import {
  UI_SET_LOADER,
  UI_SET_MENU,
  UI_SET_NOTIFICATIONS_MENU,
  UI_SET_LOADER_TEXT,
  SET_UI_PROPERTY,
  UI_UPDATE_FROM_PARTNER,
  UI_UPDATE_TOWNS_BY_CP_CACHE,
  UI_UPDATE_MASTER_DATA,
  SET_PARTNER_DATA
} from 'store/actions/ui';
import { setValueObjectByField } from 'helpers/object';

export default {
  [SET_UI_PROPERTY]: (state, { field, value }) => {
    setValueObjectByField(state, field, value);
  },

  [UI_SET_LOADER]: (state, loading) => {
    state.loader = loading;
  },

  [UI_SET_MENU]: (state, opening) => {
    state.openNavMenu = opening;
  },

  [UI_SET_NOTIFICATIONS_MENU]: (state, opening) => {
    state.openNotificationsMenu = opening;
  },

  [UI_SET_LOADER_TEXT]: (state, text) => {
    state.loaderText = text;
  },

  [UI_UPDATE_FROM_PARTNER]: (state, data) => {
    const { footer = { logos: [] }, support } = data;
    state.footerLogos = footer.logos;
    state.footerPubli = footer.logoPubli;
    state.disclaimer = footer.disclaimer;
    state.support = support;
  },

  [UI_UPDATE_TOWNS_BY_CP_CACHE]: (state, { cp, towns }) => {
    state.townsCache[cp] = towns;
  },

  [UI_UPDATE_MASTER_DATA]: (state, data) => {
    const { brands } = data;
    // state.streetType = streetType;
    // state.maritalStatus = maritalStatus;
    // state.profession = profession;
    // state.sex = sex;
    // state.signType = signType;
    state.brands = brands;
  },

  [SET_PARTNER_DATA]: (state, data) => {
    const { logoFrontLeft, logoFrontRight, theme } = data;
    state.headerLogos.logoFrontLeft = logoFrontLeft;
    state.headerLogos.logoFrontRight = logoFrontRight;
    state.theme = theme;
  }
};
